import { installConnectionSensing } from "@api/reachabilityMiddleware";
import { installAuthMiddleware } from "@auth/refreshMiddleware";
import { BrowserGate } from "@scribenote/brian-design-system";
import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./index.css";
import { initRum } from "./observability/rum";

// Captures errors from render onward; a bad `env-config.js` shows in Datadog as zero sessions, not an error.
initRum();

installAuthMiddleware();
installConnectionSensing();

const ChartPreview = import.meta.env.DEV
  ? lazy(() => import("@agent/dev/ChartPreview"))
  : null;
const onLocalhost = ["localhost", "127.0.0.1"].includes(
  window.location.hostname,
);
const showCharts =
  import.meta.env.DEV &&
  onLocalhost &&
  window.location.pathname === "/dev/charts";

// The room sim run viewer reads runs from this machine through the dev server, so like the charts it is outside the app and absent from every build.
const SimViewer = import.meta.env.DEV
  ? lazy(() => import("@sim/SimViewer"))
  : null;
const showSim =
  import.meta.env.DEV && onLocalhost && window.location.pathname === "/dev/sim";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserGate>
      {showCharts && ChartPreview ? (
        <Suspense fallback={null}>
          <ChartPreview />
        </Suspense>
      ) : showSim && SimViewer ? (
        <Suspense fallback={null}>
          <SimViewer />
        </Suspense>
      ) : (
        <App />
      )}
    </BrowserGate>
  </StrictMode>,
);
